<template>
    <div :class="classes" :style="styles">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'link-row',
        props: {
            flex: {
                type: Boolean
            },
            align: {
                type: String,
                default: 'middle',
                validator(val) {
                    return LinkUtils.oneOf(val, ['top', 'middle', 'bottom']);
                },
            },
            justify: {
                type: String,
                default: 'start',
                validator(val) {
                    return LinkUtils.oneOf(val, ['start', 'end', 'center', 'space-around', 'space-between']);
                },
            },
            gutter: {
                type: [Number, String],
                default: 0,
            },
            className: {
                type: String
            },
        },
        computed: {
            classes() {
                return [
                    'link-row',
                    {
                        'link-row-flex': !!this.flex,
                        [`link-row-flex-${this.align}`]: !!this.align,
                        [`link-row-flex-${this.justify}`]: !!this.justify,
                        [`${this.className}`]: !!this.className,
                    }
                ];
            },
            styles() {
                let style = {};
                if ((this.gutter - 0) !== 0) {
                    style = {
                        marginLeft: (this.gutter - 0) / -2 + 'px',
                        marginRight: (this.gutter - 0) / -2 + 'px'
                    };
                }
                return style;
            },
        },
        watch: {
            gutter(val) {
                this.updateGutter();
            },
        },
        methods: {
            updateGutter() {
                const cols = this.$children.reduce((ret, item) => {
                    if (item.$options.name === 'link-col') ret.push(item);
                    return ret;
                }, []);
                (!!cols.length && (this.gutter - 0) !== 0) &&
                cols.forEach((child) => child.gutter = (this.gutter - 0));
            },
        },
    };
</script>
<style lang="scss">
    /*---------------------------------------variables-------------------------------------------*/

    $cell-num: 24;

    /*屏幕大小*/
    /*$screen-xs*/
    $screen-sm: 768px;
    $screen-md: 992px;
    $screen-lg: 1200px;
    $screen-xl: 1920px;

    $screens: (
        xs:(max-width:$screen-sm),
        sm:(min-width:$screen-sm),
        md:(min-width:$screen-md),
        lg:(min-width:$screen-lg),
        xl:(min-width:$screen-xl),
    );

    $flexs: (
        start:(justify-content:flex-start),
        center:(justify-content:center),
        end:(justify-content:flex-end),
        space-between:(justify-content:space-between),
        space-around:(justify-content:space-around),
        top:(align-items:flex-start),
        middle:(align-items:center),
        bottom:(align-items:flex-end),
    );

    /*---------------------------------------grid styles-------------------------------------------*/

    .link-row {
        height: auto;
        position: relative;
        display: block;
        @include clear-fix;
        &, & * {
            box-sizing: border-box;
        }

        /*flex布局*/
        &.link-row-flex {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            &:before,
            &:after {
                display: flex;
            }
            /*flex布局*/
            @each $flexType, $flexValue in $flexs {
                &.link-row-flex-#{$flexType} {
                    @each $key, $value in $flexValue {
                        #{$key}: #{$value}
                    }
                }
            }
        }
        /*响应式*/
        .link-col {
            display: block;
            float: left;

            @for $i from 1 through $cell-num {
                &.link-col-span-#{$i} {
                    width: (1 / $cell-num * $i * 100) * 1%;
                }
                &.link-col-offset-#{$i} {
                    margin-left: (1 / $cell-num * $i * 100) * 1%;
                }
                &.link-col-pull-#{$i} {
                    position: relative;
                    right: (1 / $cell-num * $i * 100) * 1%;
                }
                &.link-col-push-#{$i} {
                    position: relative;
                    left: (1 / $cell-num * $i * 100) * 1%;
                }
                &.link-col-order-#{$i} {
                    order: $i;
                }
            }

            @each $size, $px in $screens {
                @include res(inspect($size)) {
                    @for $i from 1 through $cell-num {
                        &.link-col-#{$size}-#{$i} {
                            width: (1 / $cell-num * $i * 100) * 1%;
                        }
                    }
                }
            }
        }
    }
</style>
